export const URL = '/v1/accomodation-count/'

export type Req = void

export type Resp = {
  count: number
}